var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-hrom"},[_c('Icon',{attrs:{"type":"ios-megaphone","size":"20"}}),_c('span',[_vm._v("\n        {{}}\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }